import { render, staticRenderFns } from "./NewsDetailsSix.vue?vue&type=template&id=cffc6384"
import script from "./NewsDetailsSix.vue?vue&type=script&lang=js"
export * from "./NewsDetailsSix.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailsSix.vue?vue&type=style&index=0&id=cffc6384&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports